import { render, staticRenderFns } from "./checkboxGroup.vue?vue&type=template&id=52ca43b0&scoped=true"
import script from "./checkboxGroup.vue?vue&type=script&lang=js"
export * from "./checkboxGroup.vue?vue&type=script&lang=js"
import style0 from "./checkboxGroup.vue?vue&type=style&index=0&id=52ca43b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ca43b0",
  null
  
)

export default component.exports